"use client";

import { createContext, useContext } from "react";

export interface CurrencyPrices {
  basicPrice: string;
  premiumPrice: string;
  rebateAmount: string;
}

// The server component that renders the cards (ActivePricingCards, or a page
// rendering PricingCard) supplies the request's prices to both SSR and
// hydration. Without a provider, callers keep their translated price fallback.
export const CurrencyPricesContext = createContext<CurrencyPrices | null>(null);

export function useCurrencyPrices(): CurrencyPrices | null {
  return useContext(CurrencyPricesContext);
}
